module.exports = __webpack_public_path__ + "img/ajuan.14100e6.png";